export default __webpack_public_path__ + "static/media/menu-bg.c5bd4455.jpg";